import React from 'react';
import { node } from 'prop-types';

import styles from './CloudGradientSection.scss';

import BgWhiteAbsractTop from './images/img_mission_cloud01.svg';
import BgWhiteAbsractBottom from './images/img_mission_cloud02.svg';

export default function CloudGradientSection({ children }) {
  return (
    <div className={styles.root}>
      <div className={styles.gradientBackground} />
      <img src={BgWhiteAbsractTop} className={styles.topAbstract} />
      <img src={BgWhiteAbsractBottom} className={styles.bottomAbstract} />
      {children}
    </div>
  );
}

CloudGradientSection.propTypes = {
  children: node,
};

CloudGradientSection.defaultProps = {
  children: null,
};



// WEBPACK FOOTER //
// ./app/containers/Mission/components/CloudGradientSection/CloudGradientSection.jsx